import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		user_info: {},//用户信息
		// baseUrl: BASEURL + '//health.qingleitech.com',      // 生产环境
		baseUrl: process.env.NODE_ENV === 'production' ? window.location.origin : window.location.protocol + '//dev.qingleitech.com',
		// baseUrl: BASEURL + '//ccyy.qingleitech.com', // 清雷测试环境
		// baseUrl: BASEURL + '//dev.tsingraytech.com',      // AWS测试

		// baseUrl: 'http://192.168.1.195:9527',    // 老于本地
		// baseUrl: 'http://192.168.1.79:9527',    // 老祥达本地

		// 福寿康相关
		// baseUrl: 'http://172.21.0.124:9527', //于俊伟-福寿康测试
		// baseUrl: 'http://172.22.0.211:9527', //于俊伟-福寿康生产

		// 爱赡养相关
		// baseUrl: 'http://192.168.7.3:9527', //于俊伟-爱赡养测试
		// baseUrl: 'http://10.0.5.2:9527', //于俊伟-爱赡养生产

		// 安益同相关
		// baseUrl: 'http://47.95.146.239:9527', //于俊伟-安益同测试
		// baseUrl: 'http://172.16.19.207:9527', //于俊伟-安益同生产

		// 远盟相关
		// baseUrl: 'http://yuanmeng.qingleitech.com', //于俊伟-远盟测试


		installX: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200],

		aiSingleReportData: null,

		// 是否包含测量
		isContainMeasure: false
	},
	mutations: {
		stateFun(state, data) {//修改vuex值通用方法
			return (state[data.name] = data.val ? data.val : "")
		},
		changeAiSingleReportData(state, data) {
			state.aiSingleReportData = data;
		},
		changeIsContainMeasure(state, data) {
			state.isContainMeasure = data;
		}
	},
	actions: {},
	modules: {}
});
